// Item types the home page search can find. The values are also what the API's
// POST /globalsearch accepts in `types` and returns as each hit's `type`.
export enum GlobalSearchType {
  Dashboard = 'Dashboard',
  Sensor = 'Sensor',
  SensorGroup = 'SensorGroup',
  Gateway = 'Gateway',
  Event = 'Event',
  ActionQueue = 'ActionQueue',
  ChartFavorite = 'ChartFavorite',
  MapFavorite = 'MapFavorite',
  ImageFavorite = 'ImageFavorite',
  Import = 'Import',
  UserGroup = 'UserGroup'
}

// What POST /globalsearch returns for each match.
export interface GlobalSearchHitInfo {
  type: string;
  id: number;
  title: string;
  subtitle?: string;
  matchedField: string;
  matchedText: string;
  userName?: string;
  userGroupId?: number | null;
}

export interface GlobalSearchCriteria {
  searchText: string;
  types: string[];
  maxPerType: number;
}

export interface SearchResultLink {
  label: string;
  route: string;
  queryParams?: { [key: string]: string | number };
}

// Who owns a result, for the access check that decides whether the user may see it.
export interface SearchResultOwner {
  userName?: string;
  userGroupId?: number | null;
}

// One result as the home page shows it: where it is, what matched, and where to go.
export interface SearchResult {
  type: GlobalSearchType;
  id: number;
  title: string;
  subtitle?: string;
  matchedField: string;
  matchedText: string;
  rank: number;
  link: SearchResultLink;
  extraLinks: SearchResultLink[];
  owner: SearchResultOwner;
}

export interface SearchResultGroup {
  type: GlobalSearchType;
  label: string;
  pageName: string;
  results: SearchResult[];
}

// The home page remembers its last search for the browser tab (sessionStorage), so the text and results
// are still there after the user follows a result and comes back.
export const HOME_SEARCH_STATE_KEY = 'HomeSearchLastState';
export const HOME_SEARCH_STATE_VERSION = 1;

export interface SavedHomeSearch {
  version: number;
  // Who the results were filtered for; another user's results are never shown
  username: string;
  text: string;
  outcome: { groups: SearchResultGroup[]; total: number; incomplete: boolean };
  // The groups the user opened with "Show more"
  expanded: GlobalSearchType[];
  scrollY: number;
  savedAt: number;
}
